import React, { FC, ReactNode } from 'react';

import { IMainMenuView } from '@rbi-ctg/menu';

import {
  IMainMenuContext,
  useMainMenuContext as legacyUseMainMenuContext,
} from './legacy-main-menu';
import {
  MainMenuProvider as NewMainMenuContextProvider,
  useMainMenuContext as newUseMainMenuContext,
} from './new-main-menu';

export type MainMenu = IMainMenuView;
export type MainMenuContext = IMainMenuContext;
export const useNewMainMenuContext = newUseMainMenuContext;
export const useMainMenuContext = legacyUseMainMenuContext;

export const MainMenuProvider: FC<{ children: ReactNode }> = ({ children }) => {
  return <NewMainMenuContextProvider>{children}</NewMainMenuContextProvider>;
};
